var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "50px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.488,68.439V31.561c3.232-1.769,5.424-5.199,5.424-9.143c0-5.753-4.664-10.417-10.417-10.417 c-3.559,0-6.698,1.788-8.577,4.512H31.083c-1.879-2.724-5.018-4.512-8.577-4.512c-5.753,0-10.417,4.664-10.417,10.417 c0,3.944,2.192,7.375,5.424,9.143v36.877c-3.232,1.769-5.424,5.199-5.424,9.143c0,5.753,4.664,10.417,10.417,10.417 c4.371,0,8.107-2.695,9.653-6.512h35.682c1.546,3.816,5.282,6.512,9.653,6.512c5.753,0,10.417-4.664,10.417-10.417 C87.911,73.638,85.719,70.208,82.488,68.439z M27.488,68.432V31.568c2.054-1.121,3.689-2.912,4.61-5.081h35.806 c0.921,2.168,2.556,3.96,4.61,5.081v36.864c-1.379,0.752-2.561,1.813-3.473,3.081H30.961 C30.049,70.244,28.866,69.184,27.488,68.432z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotate);
export default __webpack_public_path__ + "static/media/annotate.be0db0d1d3f891ed370f67faebe530b1.svg";
export { ForwardRef as ReactComponent };